import { lazy, Suspense } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';

// KitchenSink is a dev-only page — lazy-import only in development so it is
// tree-shaken from the production bundle entirely.
const KitchenSink = import.meta.env.DEV
  ? lazy(() => import('@/pages/dev-kitchen-sink').then((m) => ({ default: m.KitchenSink })))
  : null;

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
});

function NotFoundPage() {
  const { _splat } = Route.useParams();

  if (_splat === 'dev-kitchen-sink' && KitchenSink) {
    return (
      <Suspense fallback={null}>
        <KitchenSink />
      </Suspense>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground">Page not found.</p>
      <Link to="/dashboard" className="text-primary underline underline-offset-4">
        Back to Dashboard
      </Link>
    </div>
  );
}
